<!--
 * @Description: 标签详情页面
 * @Author: mdb
 * @Date: 2023-04-19 18:13:45
 * @LastEditTime: 2023-04-19 18:48:38
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="view" title="标签详情" subdomain="lbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from '@/views/marketing/marketingManage/tagsManage/components/DetailForm.vue'
</script>
<script lang="ts">
export default { name: 'DcCosLbuTagManageView' }
</script>

<style scoped></style>
